export const AUTH_DATA_SET = 'AUTH_DATA_SET'
export const AUTH_DATA_RESET = 'AUTH_DATA_RESET'
